import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import toast, { Toaster } from 'react-hot-toast';
import { MdClear } from "react-icons/md";
import HabitacionService from '../../services/habitacion.service';
import './CargarFichero.css';

const PopUpConfirmCargarFichero = (props) => {
	const [t] = useTranslation("global");
	const toastErrorCargarFichero = () => toast.error(t('app.error.cargarFicheroError'));

	useEffect(() => {
		

	}, []);
	
	const borrar = async () => {
		
		convertToBase64(props.selectedEstablecimiento, props.selectedFichero, 1);
	}
	
	const mantener = async () => {
		
		convertToBase64(props.selectedEstablecimiento, props.selectedFichero, 0);
	}
	
	const cancelar = () => {
		props.limpiarFichero();

		// Close popup
		props.toggle();
	}
	
	const convertToBase64 = (establecimientoId, file, borrar) => {
	    const reader = new FileReader();
	    reader.readAsDataURL(file);
	    reader.onloadend = () => {
			
			const fileName = file.name.split('.').shift();
			
			const fichero = {
				nombre: fileName,
				contenido: reader.result.slice(reader.result.indexOf(",") + 1)
			}
			
			cargarFicheroHabitaciones(establecimientoId, fichero, borrar);
			
	    };
	    reader.onerror = (error) => {
	      toastErrorCargarFichero();
	    };
	  };
	
	const cargarFicheroHabitaciones = async (establecimientoId, fichero, borrar) => {
		const toastLoading = toast.loading(t('app.mensaje.loading'));
		
		await HabitacionService.cargarFicheroHabitaciones(establecimientoId, fichero, borrar)
			.then((response) => {
				if (response.status === 200) {
					props.loadHabitaciones();
					
					toast.dismiss(toastLoading);
					
					props.limpiarFichero();
					
					// Close popup
					props.toggle();
				} else {
					toast.dismiss(toastLoading);
					
					toastErrorCargarFichero();
				}
			}
		);
	}

	return (
		<div className="popup">
			<div className="popup-inner">
				<div className="popup-Header">
					<h1 className={"popup-Title"}>{t("app.label.confirmar")}</h1>
					<button className="popup-btn-x" onClick={cancelar}><MdClear /></button>
				</div>

				<div className="popup-Content">
					<form className="form-nuevaCama">
						<div className="popup-div-inputs">
							<p className="confirmText">{t("app.habitacion.cargarFicheroConfirmText")}</p>
							
							<div className="popup-div-buttons-confirm">
								<button type="button" className="btn-general-colorPink" onClick={cancelar}>{t("app.label.cancelar")}</button>
								<button type="button" className="btn-general" onClick={borrar}>{t("app.habitacion.btnBorrarYGuardar")}</button>
								<button type="button" className="btn-general" onClick={mantener}>{t("app.habitacion.btnMantenerYGuardar")}</button>
							</div>
							
						</div>
					</form>
				</div>
			</div>
			<Toaster />
		</div>
	)
}

export default PopUpConfirmCargarFichero;







